import Axios from "@/plugins/Axios";

export class PlanosBimestraisService {
  async planoBimestral(gestaoDeAulaId, bimestre) {
    const response = await Axios().get(
      `planos-bimestrais/plano-bimestral/${gestaoDeAulaId}/${bimestre}`
    );
    return response.data;
  }

  async createOrUpdate(plano) {
    const response = await Axios().post(`planos-bimestrais/criar-plano-bimestral`, {
      plano,
    });
    return response.data;
  }

  async createOrUpdateInfantil(plano) {
    const response = await Axios().post("planos-bimestrais-infantil/criar-plano-bimestral", {
      plano,
    });
    return response.data;
  }

  async exportarDescritores(descritores) {
    const response = await Axios().post("planos-bimestrais/exportar-descritores", {
      descritores,
    });
    return response.data;
  }

  async disciplinas() {
    const response = await Axios().get(`planos-bimestrais/disciplinas`);
    return response;
  }

  async turmas() {
    const response = await Axios().get(`planos-bimestrais/turmas`);
    return response;
  }

  async bimestres() {
    const response = await Axios().get(`planos-bimestrais/listarBimestres`);
    return response;
  }

  async index(pageNumber, query, turma, disciplina, bimestre) {
    const planos = await Axios().get(
      `planos-bimestrais/planos-bimestrais?page=${pageNumber}&query=${query}&turma=${turma}&disciplina=${disciplina}&bimestre=${bimestre}`
    );
    return planos.data;
  }

  async show(planoId) {
    const response = await Axios().get(`planos-bimestrais/${planoId}/visualizar`);
    return response;
  }

  async pdf(planoId) {
    const base64 = await Axios()
      .get(`planos-bimestrais/${planoId}/relatorio`, { responseType: "arraybuffer" })
      .then((response) => Buffer.from(response.data, "binary").toString("base64"));
    return `data:application/pdf;base64, ${base64}`;
  }

  async update(planoId, statusId) {
    const response = await Axios().put(
      `planos-bimestrais/${planoId}/${statusId}/atualizarSituacao`
    );
    return response.data;
  }

  async planoBimestralPDF(gestaoDeAulaId, bimestre, file) {
    const formData = new FormData();
    formData.append("file", file);

    const response = await Axios().post(
      `planos-bimestrais/uploadPdf/${gestaoDeAulaId}/${bimestre}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const resultData = response.data ?? response;
    if (resultData) {
      return resultData;
    }
    return null;
  }

  async planoBimestralDownload(gestaoDeAulaId, bimestre) {
    const response = await Axios()
      .get(`planos-bimestrais/downloadPdf/${gestaoDeAulaId}/${bimestre}`, {
        responseType: "blob",
      })
      .then((response) => {
        const a = document.createElement("a");
        a.href = window.URL.createObjectURL(response.data);
        window.open(a.href);
      });

    return response;
  }

  async pdfAnexado(planoId) {
    const base64 = await Axios()
      .get(`planos-bimestrais/${planoId}/relatorioAnexado`, { responseType: "arraybuffer" })
      .then((response) => Buffer.from(response.data, "binary").toString("base64"));
    return `data:application/pdf;base64, ${base64}`;
  }

  async visualizarPath(path) {
    const response = await Axios().get(`planos-bimestrais/visualizar-path/${path}`, {
      responseType: "arraybuffer",
    });
    return response.data;
  }
}
export default new PlanosBimestraisService();
